import type { GrupoExtratoPagarmeModel } from "../models/extratoPagarmeFornecedorModel"

export enum ExtratoPagarmeFornecedorActionsTypes {
    CARREGAR = "CARREGAR",
    SET_DATA_INICIO = "SET_DATA_INICIO",
    SET_DATA_FIM = "SET_DATA_FIM",
}

export type ExtratoPagarmeFornecedorActions =
    | {
          type: ExtratoPagarmeFornecedorActionsTypes.CARREGAR
          payload: {
              grupos: GrupoExtratoPagarmeModel[]
              saldo: string
          }
      }
    | { type: ExtratoPagarmeFornecedorActionsTypes.SET_DATA_INICIO; payload: string }
    | { type: ExtratoPagarmeFornecedorActionsTypes.SET_DATA_FIM; payload: string }
